var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.panel ? 'cp-bar cp-bar--hue' : 'hue',on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.selectHue.apply(null, arguments)}}},[_c('canvas',{ref:"canvasHue"}),_c('div',{class:_vm.panel ? 'cp-bar__thumb' : 'slide',style:(_vm.slideHueStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }